export default "__VITE_ASSET__CWaEt6kD__"